import { PlansPopup } from "@components/molecules/PlansPopup";
import { GoogleServicesTemplate } from "@components/templates/googleServices";

export const Plans = () => {
    return (
        <GoogleServicesTemplate navbar={<></>}>
            <PlansPopup />
        </GoogleServicesTemplate>
    );
};
